export default __webpack_public_path__ + "static/prompts-3ca5a96597c9c2067f829fe9eef09b94.png";